/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2026, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'bulb-canva-format-dialog',
  templateUrl: './canva-format-dialog.component.html',
  styleUrls: ['./canva-format-dialog.component.scss'],
  standalone: false,
})
export class CanvaFormatDialogComponent {

  constructor(private dynamicDialogRef: DynamicDialogRef) {}

  /**
   * Passes the selected export format back to the caller and closes the dialog.
   * @param format 'png' or 'pptx'
   */
  selectFormat(format: 'png' | 'pptx'): void {
    this.removeDialogFromDom();
    this.dynamicDialogRef.close(format);
  }

  /**
   * Closes the dialog without passing a format (cancels action).
   */
  closeDialog(): void {
    this.removeDialogFromDom();
    this.dynamicDialogRef.close(null);
  }

  /**
   * Removes primeng dynamic dialog from the DOM (required for AngularJS framework compatibility).
   */
  private removeDialogFromDom(): void {
    const dialogs = document.getElementsByTagName('p-dynamicdialog');
    if (dialogs && dialogs.length > 0) {
      dialogs[0].remove();
    }
  }
}
